export interface DownloadsDictionary {
  [module: string]: {
    [section: string]: DownloadFormat[];
  };
}

export interface DownloadFormat {
  path: string;
  title: string;
  eventName: string;
}

const DOWNLOADABLE_RESOURCES: DownloadsDictionary = {
  axuminResources: {
    'General Resources': [
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_imaging_interpretation_manual.pdf',
        title: 'Axumin Imaging & Interpretation Manual',
        eventName: 'Imaging & INT Manual',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_faq.pdf',
        title: 'Axumin Frequently Asked Questions',
        eventName: 'FAQ',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_snmmi_ctntraining_mcconathy.pdf',
        title: 'Axumin SNMMI/CTN Reader Training Presented by Dr. McConathy',
        eventName: 'Dr. McConathy Training',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_snmmi_training_schuster.pdf',
        title: 'Axumin SNMMI Reader Training Presented by Dr. Schuster',
        eventName: 'Dr. Schuster Training',
      },
    ],
    'Technologist Resources': [
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_pet-ct_prostate_patient_questionnaire.pdf',
        title: 'Axumin PET/CT Prostate Patient Questionnaire',
        eventName: 'Patient Questionnaire',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_injection_acquisition_criteria_card.pdf',
        title: 'Axumin Injection Acquisition Criteria Card',
        eventName: 'ACQ Criteria Card',
      },
    ],
    'Physician Resources': [
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_injection_interpretation_criteria_card.pdf',
        title: 'Axumin Injection Interpretation Criteria Card',
        eventName: 'INT Criteria Card',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Axumintraining/assets/pdfs/axumin_interpretation_report_example.pdf',
        title: 'Axumin Interpretation Report Example',
        eventName: 'INT Report Example',
      },
    ],
  },
  poslumaResources: {
    '': [
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Poslumatraining/assets/pdfs/MLR23-029-POSLUMA_Additional_Training_101823_FINAL.pdf',
        title: 'SNMMI Online Reader Training',
        eventName: 'SNMMI Online Reader Training',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Poslumatraining/assets/pdfs/MLR23-008B-POSLUMA_Interpretation_Report_Example_Imaging_Team_Website_PRC_FINAL.pdf',
        title: 'POSLUMA Interpretation Report Example',
        eventName: 'POSLUMA Interpretation Report Example',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Poslumatraining/assets/pdfs/MLR23-008A-POSLUMA_Image_Interpretation_Criteria_Card_PRC_FINAL.pdf',
        title: 'POSLUMA Image Interpretation Criteria',
        eventName: 'POSLUMA Image Interpretation Criteria',
      },
      {
        path:
          'https://bed-blueearthdiagnosticstraining.s3.us-east-1.amazonaws.com/Poslumatraining/assets/pdfs/MLR23-027-POSLUMA_Image_Acquisition_Criteria_Card_PRC_FINAL_(R.04-14-25).pdf',
        title: 'POSLUMA Image Acquisition Criteria Card',
        eventName: 'POSLUMA Image Acquisition Criteria Card',
      },
    ],
  },
};

export default DOWNLOADABLE_RESOURCES;
